/* -------------------------------------------------------------------------- */
/*                          Schema Workplan Comments                          */
/* -------------------------------------------------------------------------- */

import { schema } from 'normalizr';

export const comment = new schema.Entity('comments', {}, { idAttribute: 'commentId' });
export const comments = new schema.Array(comment);
